import { useEmployeeQuery } from '@alice-financial/alice-sdk'

export const useEmployeeAddress = () => {
  const { data: employeeData, ...queryStatus } = useEmployeeQuery()
  return {
    data: employeeData?.employee?.mailingAddress,
    ...queryStatus,
  }
}
useEmployeeAddress.getKey = () => useEmployeeQuery.getKey()
